import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DataProtectionNoticeListState, DpnListStateModel } from './data-protection-notice-list.state';
import { DataProtectionNoticeList } from '../models/data-protection-notice.model';
import {
  DataProtectionNoticeListInitialState,
  DataProtectionNoticeListLoad,
} from './data-protection-notice-list.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class DataProtectionNoticeListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<DpnListStateModel> = this.store.select(DataProtectionNoticeListState.getState);
  items$: Observable<DataProtectionNoticeList[]> = this.store.select(DataProtectionNoticeListState.getItems);
  loaded$: Observable<boolean> = this.store.select(DataProtectionNoticeListState.getLoaded);
  countrySpecificDpnList$: Observable<DataProtectionNoticeList[]> = this.store.select(
    DataProtectionNoticeListState.getCountrySpecificDpns,
  );
  defaultDpnList$: Observable<DataProtectionNoticeList[]> = this.store.select(
    DataProtectionNoticeListState.getDefaultDpns,
  );

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.Dpns).subscribe(() => {
      this.store.dispatch(new DataProtectionNoticeListLoad());
    });
  }

  setInitialState(): void {
    this.store.dispatch(new DataProtectionNoticeListInitialState());
  }
}
